import React, { useEffect, useState } from "react";
import { askAPI } from "../api/api";
import { RequestMethod } from "../api/api";
import { imgFromCoords } from "../utils/settings";
import { Hexagen } from "../types";

const SLUG_TO_CONFIG: Record<
  string,
  { apiUrl: string; title: string }
> = {
  "recently-animated": {
    apiUrl: "/api/hexagen/recent-videos",
    title: "Recently Animated",
  },
  "recently-created": {
    apiUrl: "/api/hexagen/recent",
    title: "Recently Created",
  },
  "week-top": {
    apiUrl: "/api/hexagen/most-upvoted-last-week",
    title: "Week Top",
  },
  "month-top": {
    apiUrl: "/api/hexagen/most-upvoted-last-month",
    title: "Month Top",
  },
  "alltime-top": {
    apiUrl: "/api/hexagen/most-upvoted-all-time",
    title: "AllTime Top",
  },
};

export const TopsPage: React.FC<{ slug: string }> = ({ slug }) => {
  const [list, setList] = useState<Hexagen[]>([]);
  const [loading, setLoading] = useState(true);
  const config = SLUG_TO_CONFIG[slug] || SLUG_TO_CONFIG["recently-animated"];
  const title = config?.title ?? "Tops";

  useEffect(() => {
    const url = config?.apiUrl ?? "/api/hexagen/recent-videos";
    askAPI<Hexagen[]>(url, RequestMethod.GET).then((data) => {
      setList(Array.isArray(data) ? data : []);
      setLoading(false);
    });
  }, [slug, config?.apiUrl]);

  return (
    <div className="min-h-screen bg-black text-white p-6 overflow-y-auto">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-2xl font-bold mb-2">{title}</h1>
        <a href="/" className="text-sm text-gray-400 hover:text-white mb-6 inline-block">
          ← Back to game
        </a>
        <p className="text-gray-400 text-sm mb-4">
          <a href="/tops/recently-animated">Recently Animated</a>
          {" · "}
          <a href="/tops/recently-created">Recently Created</a>
          {" · "}
          <a href="/tops/week-top">Week Top</a>
          {" · "}
          <a href="/tops/month-top">Month Top</a>
          {" · "}
          <a href="/tops/alltime-top">AllTime Top</a>
        </p>
        {loading ? (
          <p className="text-gray-400">Loading…</p>
        ) : (
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-2">
            {list.map((h) => (
              <a
                key={`${h.x}-${h.y}`}
                href={`/hex/${h.x}/${h.y}`}
                className="block rounded overflow-hidden border border-gray-700 hover:border-white transition-colors"
              >
                <img
                  src={imgFromCoords(h.x, h.y)}
                  alt={`${h.x}, ${h.y}`}
                  className="w-full aspect-square object-cover block"
                />
                <div className="text-xs p-1 truncate text-gray-400" title={h.prompt}>
                  {h.prompt?.slice(0, 30) || `(${h.x}, ${h.y})`}
                </div>
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
